import { useEffect, useState } from 'react'
import { usePageVisible } from './hooks.ts'

/** The current time, refreshed every `everyMs` while the app is on screen (a running timer needs a live clock; nothing else does). Off screen the
 *  clock stops and is set again at once on the way back: a browser throttles a hidden page's timers, but the native app's Android shell keeps its
 *  page "visible" in the background (M19b), where a clock ticking every second would only spend the battery. */
export function useNow(everyMs = 1000): number {
  const visible = usePageVisible()
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!visible) return
    setNow(Date.now())
    const id = setInterval(() => setNow(Date.now()), everyMs)
    return () => clearInterval(id)
  }, [everyMs, visible])
  return now
}
